import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { BillingInfoForm } from '../Course.styles';
import PrimaryButtonComponent from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';

const BillingAddress = ({ billingAddress, setBillingAddress, setStep }) => {
  const provinces = [
    'AB', // Alberta
    'BC', // British Columbia
    'MB', // Manitoba
    'NB', // New Brunswick
    'NL', // Newfoundland and Labrador
    'NS', // Nova Scotia
    'NT', // Northwest Territories
    'NU', // Nunavut
    'ON', // Ontario
    'PE', // Prince Edward Island
    'QC', // Quebec
    'SK', // Saskatchewan
    'YT', // Yukon
  ];
  function validateBillingAddress(address) {
    const requiredFields = [
      'firstName',
      'lastName',
      'addressLine1',
      // 'addressLine2',
      'adminArea1',
      'adminArea2',
      'countryCode',
      'postalCode',
    ];
    for (const field of requiredFields) {
      if (!address[field]) {
        return `Missing required field: ${field}`;
      }
    }
    return null;
  }
  return (
    <BillingInfoForm autoComplete="on">
      <h3>Billing Information</h3>
      <div className="side">
        {/* firstName */}
        <div>
          <label htmlFor="firstName">First Name</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={billingAddress.firstName}
            onChange={(e) =>
              setBillingAddress({
                ...billingAddress,
                firstName: e.target.value,
              })
            }
            autoComplete="given-name"
          />
        </div>
        {/* lastName */}
        <div>
          <label htmlFor="lastName">Last Name</label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            value={billingAddress.lastName}
            onChange={(e) =>
              setBillingAddress({
                ...billingAddress,
                lastName: e.target.value,
              })
            }
            autoComplete="family-name"
          />
        </div>
      </div>
      {/* addressLine1 */}
      <div className="street">
        <label htmlFor="addressLine1">Street Address</label>
        <input
          type="text"
          id="addressLine1"
          name="addressLine1"
          value={billingAddress.addressLine1}
          onChange={(e) =>
            setBillingAddress({
              ...billingAddress,
              addressLine1: e.target.value,
            })
          }
          autoComplete="address-line1"
        />
      </div>
      {/* addressLine2 */}
      <div className="side">
        <div>
          <label htmlFor="addressLine2">Apt/Suite</label>
          <input
            type="text"
            id="addressLine2"
            name="addressLine2"
            value={billingAddress.addressLine2}
            onChange={(e) =>
              setBillingAddress({
                ...billingAddress,
                addressLine2: e.target.value,
              })
            }
            autoComplete="address-line2"
          />
        </div>
        {/* adminAdrea2 */}
        <Suspense fallback={<div>Loading...</div>}>
          <div>
            <label htmlFor="adminArea2">City</label>
            <input
              type="text"
              id="city"
              name="adminArea2"
              value={billingAddress.adminArea2}
              onChange={(e) =>
                setBillingAddress({
                  ...billingAddress,
                  adminArea2: e.target.value,
                })
              }
              autoComplete="address-level2"
            />
          </div>
        </Suspense>
      </div>
      <div className="side">
        {/* postalCode */}
        <Suspense fallback={<div>Loading...</div>}>
          <div>
            <label htmlFor="postalCode">Postal Code</label>
            <input
              type="text"
              id="postalCode"
              name="postalCode"
              value={billingAddress.postalCode}
              onChange={(e) =>
                setBillingAddress({
                  ...billingAddress,
                  postalCode: e.target.value,
                })
              }
              autoComplete="postal-code"
            />
          </div>
        </Suspense>
        <div>
          {/* adminArea1 */}
          <label htmlFor="province">Province</label>
          <select
            id="province"
            name="adminArea1"
            value={billingAddress.adminArea1}
            onChange={(e) =>
              setBillingAddress({
                ...billingAddress,
                adminArea1: e.target.value,
              })
            }
            autoComplete="address-level1"
          >
            <option value="">Select a province</option>
            {provinces.map((province) => (
              <option key={province} value={province}>
                {province}
              </option>
            ))}
          </select>
        </div>
      </div>
      <PrimaryButtonComponent
        functionName={() => {
          const validationError = validateBillingAddress(billingAddress);
          if (validationError) {
            alert(validationError);
          } else {
            setStep(2);
          }
        }}
        span="Continue to Payment"
      />
    </BillingInfoForm>
  );
};
BillingAddress.propTypes = {
  billingAddress: PropTypes.object.isRequired,
  setBillingAddress: PropTypes.func.isRequired,
  setStep: PropTypes.func.isRequired,
};

export default BillingAddress;
